import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { AccountService } from 'src/app/services/account.service';
import { AuthOtpActions, AuthOtpActionTypes } from '../actions/auth-otp.actions';
import { AuthOtpType, updateInfoType } from 'src/app/shareModel';
import { UtilsService } from '../../../services/utils.service';
import * as actions from '../../../store/actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';



@Injectable()
export class AuthOtpEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private accountService = inject(AccountService);
  private utils = inject(UtilsService);

  constructor() {}

  AddAuthOtp$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.AuthOtpActionTypes.AddAuthOtp),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = {
        ...action.payload,
        otp: (action.payload.otp && action.payload.otp.length > 0) ? action.payload.otp : user.otp
      };
      return this.accountService.AddAuthOTP(payload).pipe(
        map((res: any) => {

          if (!res.Flag) {
            return new featureActions.AddAuthOtpFail(res);
          } else {
            const result = payload.AuthType === AuthOtpType.Login 
              ? { ...res, otp: payload.otp, authType: payload.AuthType }
              : { ...res, authType: payload.AuthType };
            return new featureActions.AddAuthOtpSuccess(result);
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.AddAuthOtpFail(error));
        })
      );
    })
  ));
  CheckAuthOtp$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.AuthOtpActionTypes.CheckAuthOtp),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: (action.payload.otp && action.payload.otp.length > 0) ? action.payload.otp : user.otp,
        AuthType: (action.payload.authType === AuthOtpType.LoginSW) ? AuthOtpType.Login : action.payload.authType,
        AuthId: action.payload.authId,
        AuthOTP: action.payload.authOtp,
      };
      return this.accountService.CheckAuthOtp(params).pipe(

        switchMap((res: any) => {
          if (!res.Flag) {
            return [new featureActions.CheckAuthOtpFail(res)];
          } else {
            if (action.payload.authType === AuthOtpType.Login) {
              // Add 帳號成功即登入
              const token = JSON.parse(this.utils.getToken());
              this.utils.writeToken({...token,
                value: res.OtpKey,
                timestamp: new Date().getTime(),
                username: res.Account,
                acode: Number(res.acode),
                RegionId: res.RegionId,
                Package: res.Package,
                IsMsp: res.IsMsp,
                userToken: res.token
              });
              return [new featureActions.CheckAuthOtpSuccess(res),
                new actions.LoginSuccessAction({
                  username: res.Account,
                  OtpKey: res.OtpKey,
                  acode: Number(res.acode),
                  RegionId: res.RegionId,
                  Package: res.Package,
                  IsMsp: res.IsMsp
                })];
            }
            res = {...res, authType: params.AuthType};
            return [new featureActions.CheckAuthOtpSuccess(res)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.CheckAuthOtpFail(error));
        })
      );
    })
  ));
  EnableAuthOtp$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.AuthOtpActionTypes.EnableAuthOtp),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        AuthType: action.payload.authType,
        AuthId: action.payload.authId,
      };

      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        errmsg: '',
        type: action.payload.authType === AuthOtpType.DisableUpsControl
          ? updateInfoType.UpsControlDisable
          : updateInfoType.UpsControlEnable
      };
      const isUpsControl = 
        action.payload.authType === AuthOtpType.EnableUpsControl ||
        action.payload.authType === AuthOtpType.DisableUpsControl;
      return this.accountService.EnableAuthOtp(params).pipe(
        switchMap((res: any) => {
          if (!res.Flag) {
            const result: any[] = [new featureActions.EnableAuthOtpFail()];
            if (isUpsControl) { result.push(new featureActions.UpdateInfoFailAction(updateRes)); }
            return result;
          } else {
            const result: any[] = [new featureActions.EnableAuthOtpSuccess(res)];
            if (isUpsControl) {
              result.push(new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true }));
            }
            return result;
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.EnableAuthOtpFail());
        })
      );
    })
  ));
}
